/** URL publique partagée — même lien pour tous les rôles d'une collecte. */
export function buildCollectResponderLink(responderLinkToken: string): string {
    const token = (responderLinkToken || '').trim();
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}/r/c/${encodeURIComponent(token)}`;
}
